<div *ngIf="show" class="image-container">
  <!-- <i class="fa fa-spinner" style="font-size:48px;"></i> -->
   <!-- <img [src]="spinnerSrc" style="border: none; align-items: center;" height="70" width="70"/> -->
   <span class="loaderLatest"></span>
   <br>
   Processing Request
   <!-- <div style="position: fixed; bottom: 43.5vh; align-items: center;">Processing Request</div> -->
</div>